import { render, staticRenderFns } from "./comm-attend.vue?vue&type=template&id=4d0f7153&"
import script from "./comm-attend.vue?vue&type=script&lang=js&"
export * from "./comm-attend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports